import React from "react";
import { InformationCircleIcon } from "icons/outline";
import { Input } from "ui";
import FormFieldError from "./FormFieldError";

type InputFieldProps = {
  className?: string;
  type?: "input" | "IntegerField" | "CharField" | "text" | "StringRelatedField";
  field_name: string;
  value: string;
  onChange: (name: string, value: string) => void;
  label?: React.ReactNode;
  help_text?: string;
  error_messages?: Record<string, string>;
  required?: boolean;
  step?: string;
  max?: number;
};

export default function InputField({
  type,
  value,
  required,
  field_name,
  label,
  help_text,
  error_messages,
  onChange,
  ...props
}: InputFieldProps) {
  const isLabelString = typeof label === "string";
  const placeholder = isLabelString ? `Add ${label}..` : undefined;

  return (
    <>
      <div className="sm:col-span-4">
        <Input
          label={label}
          type={type === "IntegerField" ? "number" : "text"}
          name={field_name}
          placeholder={placeholder}
          id={field_name}
          required={required}
          defaultValue={value}
          onChange={(value) => onChange(field_name, value)}
          {...props}
        />

        {help_text && (
          <p className="mt-2 inline-flex max-w-full items-start  whitespace-normal text-sm text-foundations-subtle">
            <span className="pt-1">
              <InformationCircleIcon className="h-4 w-4" />
            </span>
            <span className="pl-1">{help_text}</span>
          </p>
        )}
      </div>
      {error_messages && (
        <FormFieldError
          className="sm:col-span-6"
          errors={error_messages}
          name={field_name}
        />
      )}
    </>
  );
}
